import { useContext } from "react";
import Context, { VgtVariant } from "./Context";
import Provider from "./Provider";

export function useVariant() {
  const context = useContext(Context);
  if (!context) {
    throw new Error("useVariant must be used within a VariantProvider");
  }
  return context;
}

export { Context as VgtVariantContext, Provider as VgtVariantProvider, VgtVariant };
